const BUNDLES_CART_KEY = 'bundles_cart';

document.addEventListener('DOMContentLoaded', () => {
  resetBundleCart();
  initSemiBundleSection();
  initSemiBundleCart();
});

function resetBundleCart() {
  localStorage.removeItem(BUNDLES_CART_KEY);
}

function initSemiBundleSection() {
  const semiBundleButtons = [...document.getElementsByClassName('semi-bundle-add-button')];
  semiBundleButtons.forEach((button) => {
    button.addEventListener('click', handleAddToBundleButtonClick);
  })
}

function initSemiBundleCart() {
  // Semi bundle cart drawer display control on scroll

  if (window.innerWidth > 1024) {
    const scrollDirectionListener = createScrollDirectionListenerWithCallback(handleSemiBundleCartScroll);
    window.addEventListener('scroll', scrollDirectionListener);
  } else {
    const semiBundleMobileDrawerToggle = document.querySelector('.semi-bundle-cart-mobile-drawer-toggle');
    semiBundleMobileDrawerToggle.addEventListener('click', handleSemiBundleMobileDrawerToggleClick);
  }
}

function handleSemiBundleCartScroll(direction) {
  const semiBundleCart = document.querySelector('.semi-bundle-cart');

  if (direction === 'down') {
    semiBundleCart.style.top = window.innerHeight - semiBundleCart.getBoundingClientRect().height + 'px';
  } else {
    semiBundleCart.style.top = '100px';
  }
}

function handleSemiBundleMobileDrawerToggleClick(e) {
  const semiBundleCart = document.querySelector('.semi-bundle-cart');
  semiBundleCart.classList.toggle('semi-bundle-cart-mobile-drawer-open');
}

function handleAddToBundleButtonClick(e) {
  const productBlockElement = e.target.closest('.product-grid-item');
  const collectionHandle = productBlockElement.dataset.collectionHandle;
  const quickBuyElement = productBlockElement.querySelector('.btn--quick');

  const isQuickViewVariants = quickBuyElement.hasAttribute('data-button-quick-view') && e.target.dataset.hasVariants === 'false';
  if (isQuickViewVariants) {
    quickBuyElement.click(); 
  } else {
    const variantId = e.target.dataset.firstVariant
    const { productTitle, productPrice, productImage } = e.target.dataset;
    const variantData = {
      title: productTitle,
      price: productPrice,
      image: productImage,
      id: variantId
    }
    addVariantToBundleCart(collectionHandle, variantData)
  }
}

function addVariantToBundleCart(collectionHandle, variantData) {

  const bundlesCart = JSON.parse(localStorage.getItem(BUNDLES_CART_KEY) || '[]');

  const maxCount = getSemiBundleCollectionMaxItems(collectionHandle);
  const collectionProductsCount = bundlesCart.reduce((acc, product) => {
    if (product.collectionHandle === collectionHandle) {
      acc = acc + 1;
    }
    return acc;
  }, 0);

  if (collectionProductsCount >= maxCount) {
    return;
  }

  addItemToBundleCart({ bundlesCart, collectionHandle, variantData });
}

function addItemToBundleCart(data) {
  const { bundlesCart, collectionHandle, variantData } = data;

  bundlesCart.push({
    id: variantData.id,
    title: variantData.title,
    price: variantData.price,
    image: variantData.image,
    collectionHandle: collectionHandle,
  })

  updateBundlesCart(bundlesCart);
}

function updateBundlesCart(data) {
  localStorage.setItem(BUNDLES_CART_KEY, JSON.stringify(data));
  updateBundleGridDisplay();
  updateBundleCartInfo();
}

function getSemiBundleCollectionMaxItems(collectionHandle) {
  const bundleSection = document.querySelector('.semi-bundle-section');
  const bundleCollectionBlock = bundleSection.querySelector(`.semi-bundle-grid-block[data-collection-handle="${collectionHandle}"]`);
  return bundleCollectionBlock.dataset.maxCount
}

function updateBundleGridDisplay() {
  const bundlesCart = JSON.parse(localStorage.getItem(BUNDLES_CART_KEY));

  if (!bundlesCart) {
    return;
  }

  const bundleSection = document.querySelector('.semi-bundle-section');
  const bundleCollections = bundleSection.querySelectorAll('.semi-bundle-grid-block');

  bundleCollections.forEach((collectionElement) => updateBundleCollectionButtonsDisplay(bundlesCart, collectionElement));

  updateBundleCollectionsCurrentCount(bundlesCart, bundleSection);
}

function updateBundleCollectionsCurrentCount(bundlesCart, bundleSection) {
  const currentCountNumbers = bundleSection.querySelectorAll('.semi-bundle-grid-block-heading-current-count-number');
  currentCountNumbers.forEach((numberElement) => {
    const collectionHandle = numberElement.dataset.collectionHandle;
    const currentCount = bundlesCart.reduce((acc, product) => {
      if (product.collectionHandle === collectionHandle) {
        acc += 1;
      }
      return acc;
    }, 0);
    numberElement.textContent = currentCount.toString().padStart(2, '0');
  });
}

function updateBundleCollectionButtonsDisplay(bundlesCart, collectionElement) {
  const maxCount = collectionElement.dataset.maxCount;

  const currentCollectionProductsCountInCart = bundlesCart.reduce((acc, product) => {
    if (product.collectionHandle === collectionElement.dataset.collectionHandle) {
      acc += 1;
    }
    return acc;
  }, 0);

  const isCollectionAddToBundleCartDisabled = currentCollectionProductsCountInCart >= maxCount;
  const addToBundleCartButtons = collectionElement.querySelectorAll('.semi-bundle-add-button');
  addToBundleCartButtons.forEach(button => button.disabled = isCollectionAddToBundleCartDisabled)
}

function updateBundleCartInfo() {
  const bundlesCart = JSON.parse(localStorage.getItem(BUNDLES_CART_KEY));

  if (!bundlesCart) {
    return;
  }

  const bundleSection = document.querySelector('.semi-bundle-section');
  const semiBundleCart = document.querySelector('.semi-bundle-cart');
  const semiBundleCartItems = semiBundleCart.querySelectorAll('.semi-bundle-cart-item');

  semiBundleCartItems.forEach((item, index) => updateBundleCartItemInfo(item, bundlesCart, index));
  updateBundleCartProgressBar(bundlesCart);
  updateCartSummary(bundlesCart);
  updateBundleCartAddToCartButton(bundlesCart);
}

function updateBundleCartItemInfo(item, bundlesCart, index) {
  const isIndexInCart = bundlesCart[index];

  if (!isIndexInCart) {
    renderBundleCartItemPlaceholder(item);
    return;
  }

  renderBundleCartItem(item, bundlesCart, index);
}

function renderBundleCartItemPlaceholder(item) {
  const placeholderTemplate = document.getElementById('semiBundleCartItemPlaceHolder');
  const placeholderContent = placeholderTemplate.content.cloneNode(true);
  item.replaceWith(placeholderContent);
}

function renderBundleCartItem(item, bundlesCart, index) {
  const product = bundlesCart[index];
  const cartItemTemplate = document.getElementById('semiBundleCartItem');
  const cartItemContent = cartItemTemplate.content.children[0].cloneNode(true);
  item.replaceWith(cartItemContent);

  const discountPercentage = document.querySelector('.semi-bundle-cart').dataset.discountPercentage;

  const discountAmount = product.price * (discountPercentage / 100);
  const priceTotal = product.price - discountAmount;
  const originalPrice = convertToLocalCurrency(product.price / 100);
  const priceTotalFormatted = convertToLocalCurrency(priceTotal / 100)

  const cartItemImage = cartItemContent.querySelector('.semi-bundle-item-media');
  const cartItemTitle = cartItemContent.querySelector('.semi-bundle-cart-item-title');
  const cartItemPriceOriginal = cartItemContent.querySelector('.semi-bundle-cart-item-price-original');
  const cartItemPriceTotal = cartItemContent.querySelector('.semi-bundle-cart-item-price-total');
  const cartItemRemoveButton = cartItemContent.querySelector('.semi-bundle-cart-item-remove-button');

  cartItemImage.src = product.image;
  cartItemTitle.textContent = product.title;
  cartItemPriceOriginal.textContent = originalPrice;
  cartItemPriceTotal.textContent = priceTotalFormatted;
  cartItemRemoveButton.addEventListener('click', () => removeItemFromBundleCart(bundlesCart, index));
}

function removeItemFromBundleCart(bundlesCart, index) {
  bundlesCart.splice(index, 1);
  updateBundlesCart(bundlesCart);
}

function updateCartSummary(bundlesCart) {
  const cartSummary = document.querySelector('.semi-bundle-cart-summary');
  const discountPercentage = document.querySelector('.semi-bundle-cart').dataset.discountPercentage;
  const cartSavingTotal = cartSummary.querySelector('.semi-bundle-cart-summary-total-saving');
  const cartSummaryPriceTotal = cartSummary.querySelector('.semi-bundle-cart-summary-total-amount');
  const cartMobileSummaryPriceTotal = cartSummary.querySelector('.semi-bundle-mobile-total-amount ');

  const cartSummaryPriceTotalValue = bundlesCart.reduce((acc, product) => acc + Number(product.price), 0);
  const cartSavingTotalValue = bundlesCart.reduce((acc, product) => acc + Number(product.price) * (discountPercentage / 100), 0);

  const cartSummaryPriceTotalFormatted = convertToLocalCurrency((cartSummaryPriceTotalValue - cartSavingTotalValue) / 100)
  const cartSavingTotalFormatted = convertToLocalCurrency(cartSavingTotalValue / 100)

  cartSummaryPriceTotal.textContent = cartSummaryPriceTotalFormatted;
  cartSavingTotal.textContent = cartSavingTotalFormatted;
  cartMobileSummaryPriceTotal.textContent = cartSummaryPriceTotalFormatted;
}

function updateBundleCartProgressBar(bundlesCart) {
  const bundleCartProgressBarFilling = document.querySelector('.semi-bundle-cart-progress-bar-filling');
  const counter = document.querySelector('.semi-bundle-cart-counter-status');
  const maxCount = bundleCartProgressBarFilling.dataset.maxCount;
  const bundleCartProgressBarFillingWidth = (bundlesCart.length / maxCount) * 100;

  counter.textContent = bundlesCart.length.toString().padStart(2, '0');
  bundleCartProgressBarFilling.style.width = `${bundleCartProgressBarFillingWidth}%`;
}

function closeQuickView() {
  const quickView = document.querySelector('.popup-quick-view__close');
  quickView.click();
}

function updateBundleCartAddToCartButton(bundlesCart) {
  const addToCartButton = document.querySelector('.semi-bundle-cart-add-bundle-button');
  const maxCount = document.querySelector('.semi-bundle-cart').dataset.maxCount;
  addToCartButton.disabled = bundlesCart.length < Number(maxCount);
}

function createScrollDirectionListenerWithCallback(callback, ...args) {
  let lastScrollTop = 0;

  return function() {
      let currentScrollTop = window.scrollY || document.documentElement.scrollTop;

      if (currentScrollTop > lastScrollTop) {
          callback('down', ...args);
      } else if (currentScrollTop < lastScrollTop) {
          callback('up', ...args);
      }

      lastScrollTop = currentScrollTop;

  };
}

function convertToLocalCurrency(price) {
  const currentCurrency = Shopify.currency.active;
  return price.toLocaleString(undefined, {
    style: 'currency',
    currency: currentCurrency
  });
}

// Exported function for theme.dev.js to handle add the bundle to cart button click
async function handleAddBundleItemsToCart(e) {
  const addToCartButton = document.querySelector('.semi-bundle-cart-add-bundle-button');
  addToCartButton.disabled = true;
  addToCartButton.classList.add('semi-bundle-cart-add-bundle-button-loading');

  const bundleItems = JSON.parse(localStorage.getItem(BUNDLES_CART_KEY));

  const formattedBundleItems = bundleItems.reduce((acc, item) => {
    const itemInCart = acc.find((accItem) => accItem.id === item.id);
    if (itemInCart) {
      itemInCart.quantity += 1;
      return acc;
    }

    acc.push({
      id: item.id,
      quantity: 1
    })
    return acc;
  }, []);

  const cartItems = await fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      items: formattedBundleItems
    })
  });

  addToCartButton.classList.remove('semi-bundle-cart-add-bundle-button-loading');
  addToCartButton.disabled = false;
}

// Exported function for theme.dev.js to handle quick view
function addVariantToBundleCartFromQuickView(productHandle, variantData) {
  const bundleSection = document.querySelector('.semi-bundle-section');
  const productBlockElement = bundleSection.querySelector(`.product-grid-item[data-product-handle="${productHandle}"]`);
  const collectionHandle = productBlockElement.dataset.collectionHandle;

  addVariantToBundleCart(collectionHandle, variantData)
  closeQuickView();
}